import Grouping from './grouping';

export default class ProgressGrouping extends Grouping {
  constructor(obj) {
    super(obj);
  }

  get route() {
    const query = {
      groupingId: this.id,
    };

    return {
      name: 'progress',
      query,
    };
  }
}
